var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "wdt-custom-iconbx-block-i-icon-i",
    d: "M60.3,50.8L36,58.7c-1,0.3-1.5,1.4-1.2,2.4c0.2,0.8,1,1.3,1.8,1.3c0.2,0,0.4,0,0.6-0.1l24.3-7.9c1-0.3,1.5-1.4,1.2-2.4  C62.4,51,61.3,50.5,60.3,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "wdt-custom-iconbx-block-i-icon-ii",
    d: "M40.2,71.9L64.5,64c1-0.3,1.5-1.4,1.2-2.4c-0.3-1-1.4-1.5-2.3-1.2l-24.3,7.9c-1,0.3-1.5,1.4-1.2,2.4c0.2,0.8,1,1.3,1.8,1.3  v0C39.8,72,40,72,40.2,71.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3,73L73.1,28.3c-0.7-2.3-2.4-4.1-4.6-4.9L65,22c2.2-3.5,3.4-7.5,2.5-11.6c-1.5-7-5.5-8.3-7.7-8.5  c-5.5-0.5-11.1,4.8-13.2,9.9c-0.4,1,0.1,2.1,1,2.5c1,0.4,2-0.1,2.4-1c1.7-4.2,6.2-7.9,9.4-7.6c2.7,0.2,3.9,3.1,4.4,5.6  c0.8,3.7-0.6,7.2-3,10.3c-0.2,0.1-0.3,0.3-0.4,0.5c-6.2,7.8-18.4,13.4-18.6,13.5c-0.9,0.4-1.4,1.5-0.9,2.5c0.3,0.7,1,1.1,1.7,1.1  c0.3,0,0.5-0.1,0.7-0.2c0.3-0.1,2-0.9,4.4-2.2c0.2,2.4-1.2,4.7-3.5,5.5c-1.3,0.4-2.7,0.3-3.9-0.3c-1.2-0.6-2.1-1.7-2.5-3  c-0.9-2.7,0.6-5.7,3.3-6.6c1.3-0.4,2.7-0.3,3.9,0.3c0.9,0.5,2,0.1,2.5-0.8c0.5-0.9,0.1-2.1-0.8-2.5c-2.1-1.1-4.4-1.2-6.7-0.5  c-2.2,0.7-4.1,2.3-5.2,4.4c-1.1,2.1-1.3,4.6-0.6,6.9c0.7,2.3,2.3,4.1,4.4,5.2c1.3,0.7,2.6,1,4,1c0.9,0,1.8-0.1,2.7-0.4  c4.6-1.5,7.1-6.4,5.8-11.1c3.8-2.4,8.2-5.6,11.6-9.5l4.5,1.7c1.2,0.4,2,1.4,2.4,2.6l14.2,44.8c0.7,2.1-0.5,4.4-2.6,5.1L35.4,94.2  c-1,0.3-2.1,0.2-3-0.3c-0.9-0.5-1.6-1.3-2-2.4L16.2,46.8c-0.4-1.2-0.2-2.5,0.5-3.5l17.1-25.8c1-1.6,3-2.2,4.7-1.5l18.3,7.1  c1,0.4,2-0.1,2.4-1.1c0.4-1-0.1-2.1-1.1-2.4l-18.3-7.1c-3.3-1.3-7.1-0.1-9.1,3L13.7,41.2c-1.3,2-1.7,4.5-0.9,6.7l14.2,44.8  c0.6,2,2,3.6,3.8,4.6c1.1,0.6,2.3,0.9,3.5,0.9c0.8,0,1.6-0.1,2.4-0.4l45.8-14.9C86.4,81.5,88.6,77.1,87.3,73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/customer-support.8705cdfd2e11ebf333bf4cffce205230.svg";
export { ForwardRef as ReactComponent };